import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { Typography } from '@comparethemarketau/manor-typography';

const useStyles = createUseStyles((theme) => ({
    comparisonTitle: {
        color: theme.colors.primary800
    },
    bold: {
        fontWeight: theme.fontWeight.bold
    }
}));

const ComparisonTitle = (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    const { className } = props;

    return (
        <Typography className={classNames(classes.comparisonTitle, className)}>
            <span>Comparing</span>
            <span className={classes.bold}> car insurance</span>
        </Typography>
    );
};

ComparisonTitle.propTypes = {
    className: PropTypes.string
};

export { ComparisonTitle };
